import about from "./about";
import advantage from "./advantage";
import learn from "./learn";
import page from "./page";
import home from "./home";
import security from "./security";
import solution from "./solution";
import developer from "./developer";
import price from "./price";
import joinus from "./joinus";
import common from "./common";
import customer from "./customer";
import application from "./application";
import marketplace from "./marketplace";
import gateway from "./gateway";
import cloudOriginal from "./cloudOriginal";
import pricing from "./pricing";
import guard from "./guard";
import aboutus from "./aboutus";
import partner from "./partner";

export default {
  about,
  advantage,
  learn,
  page,
  home,
  security,
  solution,
  developer,
  price,
  joinus,
  common,
  customer,
  application,
  marketplace,
  gateway,
  cloudOriginal,
  guard,
  aboutus,
  pricing,
  partner,
};
